import { CALL_API } from '../../../middlewares/api';

import {
    REQUEST_LOGIN,
    SUCCESS_LOGIN,
    FAILURE_LOGIN,
    REQUEST_REFRESH_CLIENT_TOKEN,
    SUCCESS_REFRESH_CLIENT_TOKEN,
    FAILURE_REFRESH_CLIENT_TOKEN
} from './constants';

import { updateInfos } from '../../account/actions';
import { forceFetchPartners } from '../../partner/actions';

/**
 * Execute un appel AJAX vers le serveur pour faire une demande de login
 * Envoie au serveur le username et le password du membre
 * @param {*JSON} creds les identifiants de connexion du membre, {username: 'michel', password: 'azerty'}
 * @param {function} callback fonction executé lorsque le login à réussit
 */

export const loginUser = callback => {
    return {
        [CALL_API]: {
            endpoint: '/auth/token',
            types: [REQUEST_LOGIN, SUCCESS_LOGIN, FAILURE_LOGIN],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
};

export const refreshClientToken = callback => {
    return {
        [CALL_API]: {
            endpoint: '/auth/refresh',
            types: [
                REQUEST_REFRESH_CLIENT_TOKEN,
                SUCCESS_REFRESH_CLIENT_TOKEN,
                FAILURE_REFRESH_CLIENT_TOKEN
            ],
            successCallback: (response, dispatch) => {
                dispatch(updateInfos(response.payload.user));
                dispatch(forceFetchPartners());
                if (callback) {
                    callback();
                }
            }
        }
    };
};



// WEBPACK FOOTER //
// ./src/services/authentication/login/actions.js